import React from 'react';
import * as s from './PageOneColumn.css';

interface IPageOneColumnParams {
  body: React.ReactNode;
  header?: React.ReactNode;
  children?: React.ReactNode;
}

/**
 * Шаблон страницы "Одна колонка"
 */
export const PageOneColumn = ({ body, header, children }: IPageOneColumnParams) => (
  <>
    {header && <div className={s['header']}>{header}</div>}
    <div className={s['body']}>{body}</div>
    {children}
  </>
);
